// extracted by mini-css-extract-plugin
module.exports = {"ReviewBox":"KxFineHhdjED43s0QTxbc","ReviewBoxSmall":"_1AGcCbQAeRNjKNgDKymJhV","ReviewBoxMobile":"_2EoEZPcX8Hxz4zzkkksdE9"};